/**
 * Transcription Service
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.1.21
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ExportTranscriptionRequest { 
    format: ExportTranscriptionRequest.FormatEnum;
    mergeText?: boolean;
    includeSpeakers?: boolean;
    includeTimestamps?: boolean;
}
export namespace ExportTranscriptionRequest {
    export type FormatEnum = 'DOCX' | 'TXT' | 'SRT';
    export const FormatEnum = {
        DOCX: 'DOCX' as FormatEnum,
        TXT: 'TXT' as FormatEnum,
        SRT: 'SRT' as FormatEnum
    };
}